import loadable from '@loadable/component';

export const ImportedListingPageContainerLoadable = loadable(
  () => import('./ImportedListingPageContainer'),
  { resolveComponent: (module) => module.ImportedListingPageContainer },
);
